/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import Market from './component/market'
import { Spin } from 'antd'
import { startTime, endTime } from '../../util/index'

class ClubMarket extends React.Component {
  static defaultProps = {
    marketType: {
      list: [],
    },
    period: {
      start_time: null,
      end_time: null,
    },
    marketList: [],
    marketRecord: {
      list: [],
    },
  }
  state = {
    loading: true,
  }

  componentDidMount() {
    const data = {
      start_time: startTime(),
      end_time: endTime(),
      commodity_type: '',
      commodity_name: '',
    }
    this.props.fetchMarketList(data) //默认显示全部
    this.props.fetchMarketScaleList(
      Object.assign({}, data, { need_detail: true })
    ) //默认显示全部 销售记录
    this.props.fetchClubCommodityType().then((res) => {
      this.setState({ loading: false })
    })
  }

  componentWillUnmount() {
    this.props.getPeriod({ start_time: null, end_time: null }) //清除
  }

  render() {
    return (
      <div>
        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Market
            {...this.props}
            fetchMarketList={this.props.fetchMarketList}
            fetchMarketRecord={this.props.fetchMarketRecord}
            getPeriod={this.props.getPeriod}
            fetchTimePeriod={this.props.fetchTimePeriod}
            fetchMarketScaleList={this.props.fetchMarketScaleList}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    marketType: state.getClubMarket.marketType,
    period: state.getClubMarket.period,
    marketList: state.getClubMarket.marketList,
    marketRecord: state.getClubMarket.marketRecord,
    marketScaleList: state.getClubMarket.marketScaleList,
    incomeSum: state.getClubMarket.marketSum,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubMarket))



// WEBPACK FOOTER //
// ./src/containers/ClubMarket/index.js